define('lib/Podio.UI.SpaceContactModal',['require','translate','jquery','lib/jquery/jquery.elastic','lib/fileuploader/single','lib/Podio.Transport.SpaceContacts','lib/Podio.Event.UI','lib/Podio.UI.Modal','lib/Podio.UI','lib/Podio.FormValidation'],function (require) {

  var t = require('translate');
  var $ = require('jquery');
  require('lib/jquery/jquery.elastic');

  var fileUploaderSingle = require('lib/fileuploader/single');
  var SpaceContactsTransport = require('lib/Podio.Transport.SpaceContacts');

  var podioEventUI = require('lib/Podio.Event.UI');
  var modal = require('lib/Podio.UI.Modal');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var formValidation = require('lib/Podio.FormValidation');

  var modalWidth = 740, elmSpaceContactModal, onSuccessCallBack;

  function onSpaceContactSubmit(elmTarget, e) {
    $('#edit-name-wrapper .error-failed').remove();

    SpaceContactsTransport.createSpaceContact(elmTarget, function(responseData) {
      if(responseData.status == 'ok') {
        modal.hide();
        onSuccessCallBack(responseData);
      } else {
        elmSpaceContactModal.find('#show_extra_space_contact_fields').after('<div class="space-contact-fail error-failed">' + responseData.message + '</div>');
      }

    });
  }

  function onSpaceContactClicked(elmTarget, e) {
    $('.space-contact-modal form').submit();
  }

  function onSpaceContactKeyUp(elmTarget, e) {
    if (e.keyCode == keyCodes.Return) {
      onSpaceContactClicked(elmTarget, e);
    }
  }

  function newModal(options) {
    var modalTitle = t('Add a new space contact #space_contact');

    onSuccessCallBack = options.callback;

    modal.showLoading(modalTitle, { width: modalWidth});

    SpaceContactsTransport.getCreateSpaceContactModalLayout(options.space_id, function(responseData) {
      modal.show(responseData.data.html, { title: modalTitle, footerHtml: responseData.data.footer_html, width: modalWidth });
      setupSpaceContactForm(options);

      $('.modal-content .space-contact-modal').css('maxHeight', modal.availableHeight());

    });
  }

  function editModal(options) {
    var modalTitle = t('Edit space contact #space_contact');

    onSuccessCallBack = options.callback;

    modal.showLoading(modalTitle, { width: modalWidth});

    options['type'] = options['type'] ? options['type'] : 'space';

    SpaceContactsTransport.getUpdateSpaceContactModalLayout(options.space_id, options.profile_id, options.type, function(responseData) {
      modal.show(responseData.data.html, { title: modalTitle, footerHtml: responseData.data.footer_html, width: modalWidth });
      setupSpaceContactForm(options);

      $('.modal-content .space-contact-modal').css('maxHeight', modal.availableHeight());

    });
  }

  function setupSpaceContactForm(options) {
    var elmSpaceContactForm = $('.space-contact-modal form');
    var elmUploadBox = elmSpaceContactForm.find('.contact-avatar');

    formValidation.init(elmSpaceContactForm);

    if (options.contact_name) {
      elmSpaceContactForm.find('#space_contact_name').val(options.contact_name);
    }

    var uploader = fileUploaderSingle.render(elmUploadBox, {
      onlyAllowImages: true,
      previewImageSize : 'large'
    });

    elmSpaceContactForm.find('input[type=text]:first').focus();
    elmSpaceContactModal = $('.space-contact-modal');

    elmSpaceContactForm.find('textarea').elastic();
  }

  function onAddAnotherClicked(elmTarget, e) {
    var attribute = elmTarget.data('attribute');

    var elmHiddenFields = $('.space-contact-modal form input[name="space_contact[' + attribute + '][]"].hidden');
    elmHiddenFields.first().removeClass('hidden').css('display', 'block');

    if(elmHiddenFields.length <= 1) {
      elmTarget.hide();
    }
  }

  function onShowExtraFieldsClicked(elmTarget, e) {
    $('.space-contact-modal dl.hidden').toggle('slidedown');
    elmTarget.find('.more').toggle();
    elmTarget.find('.less').toggle();
  }

  podioEventUI.bind('submit', '.space-contact-modal form', onSpaceContactSubmit);
  podioEventUI.bind('click', '#create_space_contact_button', onSpaceContactClicked);
  podioEventUI.bind('keyup', '.space-contact-modal form input[type=text]', onSpaceContactKeyUp);
  podioEventUI.bind('click', 'a.show-more-fields', onAddAnotherClicked);
  podioEventUI.bind('click', 'a#show_extra_space_contact_fields', onShowExtraFieldsClicked);

  return {
    newModal: newModal,
    editModal: editModal
  };

});



